import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, Col, Container, Input, Row, Spinner } from "reactstrap";
import LargeSizeMomentos from "../../components/LargeSizeMomentos";
import SmallSizeMomento from "../../components/SmallSizeMomento";
import { createMomentosAction } from "../../store/actions/MomentosActions";
import { toast } from "react-toastify";
import {
    deleteDraftMomento,
    getSingleMomentoDraft,
    updateDraftMomento,
} from "../../store/actions/DraftDataAction";
import moment from "moment";

const EditDraftMomento = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const { singleDraftData, draftLoading } = useSelector(
        (state) => state.draftReducer
    );
    const { uid } = useSelector((state) => state.authUser);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [updatedMomento, setUpdatedMomento] = useState();
    const [QRCodes, setQRCodes] = useState([]);
    const [momentoAmount, setMomentoAmount] = useState();
    const [mediaToRemove, setMediaToRemove] = useState([]);
    const [QRMediaRemove, setQRMediaRemove] = useState([]);

    useEffect(() => {
        if (id) {
            dispatch(getSingleMomentoDraft(id));
        }
    }, [id]);
    useEffect(() => {
        if (singleDraftData) {
            setUpdatedMomento(singleDraftData?.momento);
            setMomentoAmount(singleDraftData?.momentoAmount);
            setTitle(singleDraftData?.momentoTitle);
            setQRCodes(singleDraftData?.qrCodes);
            setDescription(singleDraftData?.momentoDescription);
        }
    }, [singleDraftData]);
    const updateDraft = (e) => {
        e.preventDefault();
        let payload = {
            ...singleDraftData,
            momentoTitle: title,
            momentoDescription: description,
            momentoAmount: momentoAmount,
            momento: updatedMomento,
            qrCodes: QRCodes,
        };
        dispatch(
            updateDraftMomento(singleDraftData.id, payload, () => {
                toast.success("Draft Memento Updated Successfully");
                setTitle("");
                setDescription("");
                setMomentoAmount();
                history.push("/main/memento_drafts");
            })
        );
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        if (
            !title ||
            !description ||
            !momentoAmount ||
            updatedMomento.some((item) => item.title == "") ||
            updatedMomento.some((item) => item.subTitle == "") ||
            updatedMomento.some((item) => item.media == "")
        ) {
            toast.error("Please fill in all required fields.");
        } else {
            const { id, ...singleData } = singleDraftData;
            let payload = {
                ...singleData,
                momentoTitle: title,
                momentoDescription: description,
                momentoAmount: momentoAmount,
                momento: updatedMomento,
                qrCodes: QRCodes,
            };
            dispatch(
                createMomentosAction(uid, payload, () => {
                    dispatch(deleteDraftMomento(singleDraftData.id, () => {}));
                    toast.success("Memento Added Successfully");
                    setTitle("");
                    setDescription("");
                    setMomentoAmount();
                    history.push("/main/mementos");
                })
            );
        }
    };

    return (
        <>
            <Container fluid>
                <Row className="justify-content-center mx-4 py-3">
                    <h3>Update Draft Memento</h3>
                </Row>
                <Container>
                    <Card className=" p-4 create_momento-card">
                        <Row className="d-flex flex-column justify-content-center align-items-center p-2">
                            <Col lg={10} md={10} sm={10}>
                                <Row className="d-flex justify-content-center justify-content-lg-between align-items-center p-2">
                                    <Col
                                        lg={4}
                                        sm={10}
                                        className="mb-3 mb-lg-0"
                                    >
                                        <Input
                                            placeholder="Enter Memento Title"
                                            type="text"
                                            value={title}
                                            onChange={(e) =>
                                                setTitle(e.target.value)
                                            }
                                        />
                                    </Col>
                                    <Col lg={4} sm={10}>
                                        <Input
                                            type="text"
                                            placeholder="Enter Memento Description"
                                            value={description}
                                            onChange={(e) =>
                                                setDescription(e.target.value)
                                            }
                                        />
                                    </Col>
                                    <Col lg={4} sm={10}>
                                        <Input
                                            type="number"
                                            min={1}
                                            placeholder="Enter Memento Amount"
                                            value={momentoAmount}
                                            onChange={(e) =>
                                                setDescription(e.target.value)
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        {singleDraftData?.momentoSize == 14 ? (
                            <LargeSizeMomentos
                                momento={updatedMomento}
                                setMomento={setUpdatedMomento}
                                QRCODES={QRCodes}
                                setQRCODES={setQRCodes}
                                setMediaToRemove={setMediaToRemove}
                                setQRMediaRemove={setQRMediaRemove}
                            />
                        ) : (
                            <SmallSizeMomento
                                momento={updatedMomento}
                                setMomento={setUpdatedMomento}
                                QRCODES={QRCodes}
                                setQRCODES={setQRCodes}
                                setMediaToRemove={setMediaToRemove}
                                setQRMediaRemove={setQRMediaRemove}
                            />
                        )}
                    </Card>
                    <Row className="d-flex justify-content-center my-4 gx-5">
                        <Col className="col-6 d-flex justify-content-end">
                            <Button
                                color="primary"
                                className="text-white"
                                onClick={handleSubmit}
                            >
                                {draftLoading ? (
                                    <Spinner size="sm" className="mx-5" />
                                ) : (
                                    "Publish Memento"
                                )}
                            </Button>
                        </Col>
                        <Col className="col-6">
                            <Button
                                color="warning"
                                className="text-white"
                                onClick={updateDraft}
                            >
                                {draftLoading ? (
                                    <Spinner size="sm" className="mx-5" />
                                ) : (
                                    "Update Draft"
                                )}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    );
};

export default EditDraftMomento;
